import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fromEntries',
	// Maps don't change reference when values update
	pure: false
})
export class FromEntriesPipe implements PipeTransform {

	transform(value: Map<string, unknown> | null) {
		return value ? Object.fromEntries(value) : {};
	}

}
